import React from 'react';
import { styled } from 'linaria/react';
import t from '@jetshop/intl';

import { theme } from '../Theme';

const MarkerContainer = styled('div')`
  position: relative;
  display: inline-block;
  cursor: pointer;
  &.active {
    span {
      color: ${theme.colors.darkgrey};
    }
  }

  span {
    font-style: normal;
    font-weight: normal;
    font-size: 13px;
    line-height: 15px;
    letter-spacing: 0.03em;
    color: #333;
    text-decoration: underline;
  }

  .show-on-map:hover {
    color: ${theme.colors.blue};
  }
`;

export const StoreMarker = ({ nr, active, large, ...rest }) => {
  return (
    <MarkerContainer className={active ? ' active' : ''} {...rest}>
      <span className={'show-on-map'}>{t('Show on map')}</span>
    </MarkerContainer>
  );
};
